import { useQuery } from 'react-query';

import { getClustersList as queryFn } from 'api/endPoints/getClustersList';
import { QueryKeys } from 'api/queryKeys';

import { CompareOptions } from 'components/pages/DurationForecastPage/components/CompareTo/CompareTo';

export const useQueryClustersList = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['clustersList', params],
        queryFn: () => queryFn(params),
        enabled: params.idList.length > 0 && Boolean(params.compare),
        staleTime: 300000,
    });
};

export interface QueryParams {
    idList: number[];
    projectId: number | undefined;
    compare: CompareOptions;
}

export interface QueryResponse {
    clusterList: {
        clusterId: number;
        clusterName: string;
        completedDurationHigh: number | null;
        completedDurationTypical: number | null;
        completedOverrunDaysHigh: number | null;
        completedOverrunDaysTypical: number | null;
        completedOverrunRatioHigh: number | null;
        completedOverrunRatioTypical: number | null;
        fileMetaData: number | null;
        plannedDurationHigh: number | null;
        plannedDurationTypical: number | null;
    }[];
}
